import { lazy } from 'react';
import { useEffect } from 'react';
import Cookies from 'js-cookie'
// project imports
// import Loadable from 'ui-component/Loadable';
// import MinimalLayout from 'layout/MinimalLayout';
import AuthLogin from '../views/pages/AuthLogin';
import AuthOTPVerification from '../views/pages/AuthOTPVerification';
import OnboardingLayout from 'layout/MainContent/OnboardingLayout';
import AuthLayout from 'layout/MainContent/AuthLayout';
import { Outlet, useNavigate } from 'react-router-dom';
import SingleSignOn from 'views/pages/SingleSignOn';
import GiveawayLanding from 'views/pages/Giveaway'
import OnboardingV2 from '../views/profile/onboarding-v2';

// Logout component that redirects to home
const LogoutComponent = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);
  return null;
};

// // login option 3 routing
// const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
// const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '',
    // element: <></>,
    children: [
        // {
        //     path: '',
        //     element: <OnboardingV2 />,
        // },
        // {
        //     path: '/onboardingv2',
        //     element: <OnboardingV2 />,
        // },
        {
            path: '/logout',
            element: <LogoutComponent />,
        },
        {
            path: '',
            element: <AuthLayout> <Outlet /></AuthLayout>,
            children: [
                {
                    path: '/',
                    element: <AuthLogin />,
                    // element: <Login />,
                },
                {
                    path: '/login',
                    element: <AuthLogin />,
                },
                // {
                //     path: '/verification',
                //     element: <OTPVerification />,
                // },
                {
                    path: '/verification',
                    element: <AuthOTPVerification />,
                },
                {
                    path: '*',
                    element: <AuthLogin />,
                },
            ]
        },
        {
            path: '',
            element: <OnboardingLayout> <Outlet /></OnboardingLayout>,
            children: [
                {
                    path: '/cHJpdmF0ZS1yb3V0ZQ==',
                    element: <SingleSignOn />,
                },
            ]
        },
        {
            path: 'fundraising-fastforward-giveaway',
            element: <><GiveawayLanding /></>
        }
    ]
}

export default AuthenticationRoutes;
